import { INTRO_IMAGE } from './content';
import * as styles from './IntroSection.css';

export const IntroSection = () => (
  <section className={styles.section}>
    <div className={styles.copy}>
      <h2 className={styles.heading}>A name and number only tell half the story</h2>
      <p className={styles.body}>
        A good introduction has a lot to carry. Too often, something gets left behind. Blinq catches
        what matters, so you can make the moment count.
      </p>
    </div>
    <div className={styles.media}>
      <img
        className={styles.image}
        src={INTRO_IMAGE.src}
        width={INTRO_IMAGE.width}
        height={INTRO_IMAGE.height}
        alt="Two people talking across a table in a lounge"
        loading="lazy"
      />
    </div>
  </section>
);
